export const ELEMENT_SIZE = {
  small: 's',
  medium: 'm',
  large: 'l',
  xlarge: 'xl',
}
